import React from 'react'
import Svg from '../Svg'
import { SvgProps } from '../types'


interface IWalletIconProps extends SvgProps{
    iconTheme?: 'light' | 'dark'
}
const Icon: React.FC<IWalletIconProps> = (props) => {
    if(props.iconTheme === 'light') {
        return <Svg width="16" height="16" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M6 4C3.23858 4 1 6.23858 1 9V15C1 17.7614 3.23858 20 6 20H16C18.6776 20 20.8636 17.8953 20.9939 15.25H16.5C14.7051 15.25 13.25 13.7949 13.25 12C13.25 10.2051 14.7051 8.75 16.5 8.75H20.9939C20.8636 6.10472 18.6776 4 16 4H6ZM16.5 10.25H21V13.75H16.5C15.5335 13.75 14.75 12.9665 14.75 12C14.75 11.0335 15.5335 10.25 16.5 10.25ZM5 14.75C4.58579 14.75 4.25 15.0858 4.25 15.5C4.25 15.9142 4.58579 16.25 5 16.25H11C11.4142 16.25 11.75 15.9142 11.75 15.5C11.75 15.0858 11.4142 14.75 11 14.75H5ZM16.5 11.25C16.0858 11.25 15.75 11.5858 15.75 12C15.75 12.4142 16.0858 12.75 16.5 12.75H16.7C17.1142 12.75 17.45 12.4142 17.45 12C17.45 11.5858 17.1142 11.25 16.7 11.25H16.5Z" fill="white"/>
            <path d="M18.4873 2.99302C17.7662 1.00165 15.6601 -0.283997 13.4409 0.1729L4.84016 1.94363C3.04377 2.31348 1.58839 3.4977 0.827148 5.06305C2.01461 3.5053 3.88974 2.5 5.99966 2.5H15.9997C16.8808 2.5 17.721 2.67534 18.4873 2.99302Z" fill="white"/>
        </Svg>

    }
  return (
    <Svg viewBox="0 0 21 20" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4C3.23858 4 1 6.23858 1 9V15C1 17.7614 3.23858 20 6 20H16C18.6776 20 20.8636 17.8953 20.9939 15.25H16.5C14.7051 15.25 13.25 13.7949 13.25 12C13.25 10.2051 14.7051 8.75 16.5 8.75H20.9939C20.8636 6.10472 18.6776 4 16 4H6ZM16.5 10.25H21V13.75H16.5C15.5335 13.75 14.75 12.9665 14.75 12C14.75 11.0335 15.5335 10.25 16.5 10.25ZM5 14.75C4.58579 14.75 4.25 15.0858 4.25 15.5C4.25 15.9142 4.58579 16.25 5 16.25H11C11.4142 16.25 11.75 15.9142 11.75 15.5C11.75 15.0858 11.4142 14.75 11 14.75H5ZM16.5 11.25C16.0858 11.25 15.75 11.5858 15.75 12C15.75 12.4142 16.0858 12.75 16.5 12.75H16.7C17.1142 12.75 17.45 12.4142 17.45 12C17.45 11.5858 17.1142 11.25 16.7 11.25H16.5Z"
        fill="url(#paint0_linear_2488_84655)"
      />
      <path
        d="M18.4883 2.99302C17.7672 1.00165 15.6611 -0.283997 13.4418 0.1729L4.84113 1.94363C3.04475 2.31348 1.58936 3.4977 0.828125 5.06305C2.01559 3.5053 3.89071 2.5 6.00064 2.5H16.0006C16.8818 2.5 17.722 2.67534 18.4883 2.99302Z"
        fill="url(#paint1_linear_2488_84655)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2488_84655"
          x1="1.89744"
          y1="5.33333"
          x2="16.9424"
          y2="23.3823"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#513CFF" />
          <stop offset="1" stopColor="#23ABD4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2488_84655"
          x1="1.62057"
          y1="0.495771"
          x2="4.19813"
          y2="9.2639"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#513CFF" />
          <stop offset="1" stopColor="#23ABD4" />
        </linearGradient>
      </defs>
    </Svg>
  )
}

export default Icon
